{
    "coordinates": [
        33.70436767889714,
        72.16648842880363
    ],
    "tooltip": "Kuldana",
    "title": "Kuldana Formation",
    "country": "Pakistan",
    "period": "Paleogene",
    "alt": "TODO"
}
